import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';
import alertUserOfDeprecatedProps from '../utils/deprecation.js';
import Spinner from './Spinner.js';

var _excluded = ["as", "aria-label", "className", "children", "disabled", "fullWidth", "href", "onClick", "to", "iconOnly", "isLoading", "role", "size", "type"];
var Button = function Button(_ref, ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'button' : _ref$as,
    ariaLabel = _ref['aria-label'],
    className = _ref.className,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    fullWidth = _ref.fullWidth,
    href = _ref.href,
    onClick = _ref.onClick,
    to = _ref.to,
    iconOnly = _ref.iconOnly,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    role = _ref.role,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('Button', otherProps);
  var finalClasses = classnames('C-Button', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "--type-".concat(type), type), "--size-".concat(size), size), '--full-width', fullWidth), '--icon-only', iconOnly), "isLoading", isLoading), className);
  if (iconOnly && !ariaLabel) {
    console.error("Hey Canvas User! You need to add an aria-label to your iconOnly button so that screen readers can tell users what your button does.");
  }

  // critical for good accessibility
  var getRole = function getRole() {
    if (As === 'button') {
      return 'button';
    } else if (As === 'a') {
      return 'link';
    } else {
      return 'navigation';
    }
  };

  // if the button is disabled, do not pass on the props href, to, or onClick
  if (disabled) {
    return /*#__PURE__*/React__default.createElement("button", _extends({
      className: finalClasses,
      "aria-label": ariaLabel,
      type: type === 'submit' ? 'submit' : 'button',
      ref: ref,
      disabled: true,
      role: role ? role : getRole()
    }, otherProps), children);
  }
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses,
    "aria-label": isLoading ? 'loading, please wait' : ariaLabel,
    "aria-busy": isLoading ? true : null,
    "aria-disabled": isLoading ? true : null,
    role: role ? role : getRole(),
    type: type === 'submit' || type === 'submit-destructive' ? 'submit' : 'button',
    ref: ref,
    href: href,
    onClick: isLoading ? null : onClick,
    to: to
  }, otherProps), children, isLoading && /*#__PURE__*/React__default.createElement("div", {
    className: "C-Button__Loading"
  }, /*#__PURE__*/React__default.createElement(Spinner, {
    size: size === 'dense' ? 'inline' : 'dense'
  })));
};
Button.displayName = 'Button';
var Button$1 = /*#__PURE__*/React__default.forwardRef(Button);

export { Button$1 as default };
